import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noMatchHeader: {
    id: 'frontbucket.profile.repositories.noMatch.header',
    description: 'Header for empty state when no repos match filter criteria',
    defaultMessage: 'No repositories match',
  },
  noMatchDesc: {
    id: 'frontbucket.profile.repositories.noMatch.desc',
    description:
      'Description for empty state when no repos match filter criteria',
    defaultMessage: 'Try modifying or clearing your filter criteria.',
  },
  noReposHeader: {
    id: 'frontbucket.profile.repositories.empty.noRepos.header',
    description:
      'Header for empty state when user does not have access to any repos',
    defaultMessage: 'No repositories',
  },
  noReposDesc: {
    id: 'frontbucket.profile.repositories.empty.noRepos.desc',
    description:
      'Description for empty state when user does not have access to any repos',
    defaultMessage:
      "You don't have access to any recently updated repositories.",
  },
  clearAllFilters: {
    id: 'frontbucket.profile.repositories.clearAllFilters',
    description: 'Link in empty state to clear all filters',
    defaultMessage: 'Clear all filters',
  },
  createLink: {
    id: 'frontbucket.profile.repositories.emptyStateCreateRepositoryButton',
    description: 'A button for creating a new repository',
    defaultMessage: 'Create a repository',
  },
  description: {
    id: 'frontbucket.profile.repositories.emptyStateDescription',
    description: 'Descriptive text on profile repositories empty state screen',
    defaultMessage: 'Get started by putting some bits in your bucket.',
  },
  header: {
    id: 'frontbucket.profile.repositories.emptyStateHeader',
    description: 'Header of profile repositories empty state screen',
    defaultMessage: "You don't have any code",
  },
  importLink: {
    id: 'frontbucket.profile.repositories.emptyStateImportRepositoryButton',
    description: 'A button for importing a new repository',
    defaultMessage: 'Import a repository',
  },
  tableHeaderRepository: {
    id: 'frontbucket.profile.repositories.table.repository',
    description: 'Header name of the repositories column',
    defaultMessage: 'Repository',
  },
  tableHeaderLastUpdated: {
    id: 'frontbucket.profmessagesile.repositories.table.lastupdated',
    description: 'Header name of the last updated column',
    defaultMessage: 'Last updated',
  },
  tableHeaderBuilds: {
    id: 'frontbucket.profile.repositories.table.build',
    description: 'Header name of the Builds column',
    defaultMessage: 'Builds',
  },
  privateRepositoryIcon: {
    id: 'frontbucket.profile.repositories.table.privaterepository',
    description: 'Label of private repository icon',
    defaultMessage: 'Private repository',
  },
  updatedLabel: {
    id: 'frontbucket.profile.repositories.table.updatedLabel',
    description: 'Label for last updated date',
    defaultMessage: 'Updated',
  },
  tableHeaderDescription: {
    id: 'frontbucket.profile.repositories.table.tableHeaderDescription',
    description: 'Header name of the Description column',
    defaultMessage: 'Description',
  },
  tableHeaderSize: {
    id: 'frontbucket.profile.repositories.table.size',
    description: 'Header name of the Size column',
    defaultMessage: 'Size',
  },
  announceFilteringProcess: {
    id: 'frontbucket.profile.repositories.filteringProcess',
    description:
      'Text for the announcer of the message says that repositories are filtering',
    defaultMessage: 'Filtering repositories',
  },
  announceLoading: {
    id: 'frontbucket.profile.repositories.announceLoading',
    description:
      'The text for the announcer about repositories loading process',
    defaultMessage: 'Loading repositories',
  },
  announcePaginatedFilteringRepositories: {
    id: 'frontbucket.profile.repositories.announcePaginatedFiltering',
    description:
      'Announce how many repositories are found after filtering with pagination',
    defaultMessage:
      'Repositories have been filtered, {count, plural, one {one repository has} other {{count} repositories have}} been displayed on this page, with more repositories on others',
  },
  announceFilteringRepositories: {
    id: 'frontbucket.profile.repositories.announceFiltering',
    description: 'Announce how many repositories are found after filtering',
    defaultMessage:
      'Repositories have been filtered, {count, plural, one {one repository has} other {{count} repositories have}} been displayed',
  },
  announceFilteringNoRepositoriesFound: {
    id: 'frontbucket.profile.repositories.announceFilteringNoFound',
    description: 'Announce that no repositories are found after filtering',
    defaultMessage: 'Repositories have been filtered, no repositories found',
  },
  announceDisplayingAllRepositories: {
    id: 'frontbucket.profile.repositories.announceDisplayingAll',
    description:
      "Announce displaying all repositories, when filter doesn't applied",
    defaultMessage: 'All repositories have been displayed',
  },
});
